import React from 'react';
import { Avatar } from './Avatar';
import { Button } from './Button';
interface GuestRequestProps {
  id: string;
  name: string;
  avatar: string;
  gender: 'male' | 'female' | 'other';
  message: string;
  onAccept: () => void;
  onDecline: () => void;
  onMessage: () => void;
}
export const GuestRequest = ({
  id,
  name,
  avatar,
  gender,
  message,
  onAccept,
  onDecline,
  onMessage
}: GuestRequestProps) => {
  return <div className="border border-gray-300 rounded-lg p-4 mb-4" data-id="element-51">
      <div className="flex items-center mb-3" data-id="element-52">
        <Avatar name={name} alt={name} src={avatar} size="md" data-id="element-53" />
        <div className="ml-3" data-id="element-54">
          <h4 className="font-medium text-gray-800" data-id="element-55">{name}</h4>
          <span className="text-sm text-gray-600" data-id="element-56">{gender}</span>
        </div>
      </div>
      {message && <div className="bg-gray-100 p-3 rounded-md mb-3 text-sm text-gray-700" data-id="element-57">
          {message}
        </div>}
      <div className="flex gap-2" data-id="element-58">
        <Button variant="tertiary" size="small" onClick={onMessage} leftIcon={<div className="h-4 w-4" data-id="element-60" />} data-id="element-59">
          Message
        </Button>
        <Button variant="destructive" size="small" onClick={onDecline} data-id="element-61">
          Decline
        </Button>
        <Button variant="primary" size="small" onClick={onAccept} data-id="element-62">
          Accept
        </Button>
      </div>
    </div>;
};